import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { Fab, Tooltip } from '@mui/material';
import { useThemeMode } from '~/styles/theme';

/**
 * Alternador de tema claro/escuro, fixo no canto inferior direito.
 *
 * Vive no `App` (e não na Home) para continuar disponível em toda a jornada —
 * antes desaparecia assim que se saía da home, incluindo no ecrã de cotação.
 */
export default function ThemeModeToggle() {
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === 'dark';
  const label = isDark ? 'Ativar tema claro' : 'Ativar tema escuro';

  return (
    <Tooltip title={label}>
      <Fab
        aria-label={label}
        color="primary"
        data-app-id="app-theme-toggle"
        onClick={toggleMode}
        size="medium"
        sx={{ bottom: 24, position: 'fixed', right: 24, zIndex: (theme) => theme.zIndex.fab }}
      >
        {isDark ? <LightModeIcon /> : <DarkModeIcon />}
      </Fab>
    </Tooltip>
  );
}
